// extracted by mini-css-extract-plugin
export default {"tabs":"BlackhatMonitoringPage_tabs__HDikc","panel":"BlackhatMonitoringPage_panel__-ZWzB"};